var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-5 pt-5"},[_c('div',{staticClass:"col-lg-12 mb-5 mt-5"},[(_vm.close)?_c('h4',{staticClass:"text-center"},[_vm._v(" Payment complete. You may now close the page ")]):_vm._e(),_c('div',{attrs:{"id":"payment"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }